// extracted by mini-css-extract-plugin
module.exports = {"circularChart":"match-score-ring_circularChart__OMxkk","circleBg":"match-score-ring_circleBg__q0NMw","circle":"match-score-ring_circle__4gbD4"};